import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import MicIcon from '@mui/icons-material/Mic';
// import Button from '../Button';
import { useRequestMicPermissions, MediaPermissionsState } from './hook';
import MicrophoneChecker from '../MicrophoneChecker';
import noMicSvg from '../../assets/svgs/noMic.svg';
import closeIconSvg from '../../assets/svgs/closeIcon.svg';

const useStyles = makeStyles()((theme) => ({
    // dialog: {
    //     '& .MuiDialog-paper': {
    //         borderRadius: theme.spacing(2),
    //         padding: theme.spacing(2),
    //     },
    // },
    // content: {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     alignItems: 'center',
    //     textAlign: 'center',
    // },
    // icon: {
    //     fontSize: 80,
    //     color: theme.palette.primary.main,
    //     marginBottom: theme.spacing(2),
    // },
    // actions: {
    //     justifyContent: 'center',
    //     padding: theme.spacing(2, 0),
    // },
    // title: {
    //     fontWeight: 'bold',
    //     marginBottom: theme.spacing(1),
    // },

    dialogPaper: {
        background: 'none',
        height: '100%',
        width: '100%',
        alignContent: 'center',
        boxShadow: 'none',
        justifyContent: 'center',
    },
    dialogBox: {
        position: 'relative',
    },
    dialogContent: {
        borderRadius: theme.spacing(4),
        borderTop: '5px solid #FFAE00',
        position: 'relative',
        background: '#ffffff',
    },
    dialogTitle: {
        fontSize: '1.5em',
        fontFamily: '"Quicksand", sans-serif',
        fontWeight: 700,
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            fontSize: '1.3em',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '1em',
        },
    },
    micImageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(2),
    },
    micImage: {
        width: '10%',
    },
    micText: {
        fontSize: '1em',
        fontFamily: '"Quicksand", sans-serif',
        fontWeight: 600,
        textAlign: 'center',
        marginLeft: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            fontSize: '0.9em',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.8em',
        },
    },
    micStatus: {
        fontSize: '0.7em',
        color: '#FF0000',
        fontFamily: '"Quicksand", sans-serif',
        fontWeight: 600,
        [theme.breakpoints.down('md')]: {
            fontSize: '0.6em',
        },
    },
    permissionTextContainer: {
        padding: theme.spacing(3),
    },
    permissionText: {
        fontSize: '0.8em',
        fontFamily: '"Quicksand", sans-serif',
        fontWeight: 700,
        textAlign: 'center',
    },
    permissionSubText: {
        fontSize: '0.7em',
        fontFamily: '"Quicksand", sans-serif',
        fontWeight: 600,
        textAlign: 'center',
    },
    closeIconContainer: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
        cursor: 'pointer',
    },
    closeIcon: {
        width: '70%',
    },
    buttonContainer: {
        position: 'absolute',
        bottom: '-20px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)',
        padding: theme.spacing(0.5),
        borderRadius: '50px',
    },
    allowButton: {
        background: 'linear-gradient(to top, #309906, #32a305, #34ad04, #36b703, #38c102, #3ec909, #44d110, #4ad916, #54e121, #5ee92a, #68f132, #71f93a)',
        padding: theme.spacing(1, 5),
        borderRadius: '50px',
    },
    allowButtonText: {
        fontSize: '1.5em',
        fontFamily: '"Quicksand", sans-serif',
        fontWeight: 600,
        textAlign: 'center',
        color: '#ffffff',
    },
}));

const MicPermission = ({ context = 'course', open, onClose, onSuccess }) => {
    const { classes } = useStyles();
    const [isOpen, setOpen] = React.useState(open || false);
    const { permissionState, requestPermissions, checkPermissions } = useRequestMicPermissions();

    const handleClose = () => {
        setOpen(false);
        if (onClose && typeof onClose === 'function') {
            onClose();
        }
    };

    const handleAllow = async () => {
        const granted = await requestPermissions();
        if (granted) {
            handleClose();

            if (onSuccess && typeof onSuccess === 'function') {
                onSuccess();
            }
        }
    };

    React.useEffect(() => {
        open && setOpen(open);
    }, [open]);

    React.useEffect(() => {
        checkPermissions();

        if (!permissionState || permissionState === MediaPermissionsState.GRANTED) {
            return;
        }

        setOpen(true);

    }, [permissionState]);

    return (
        // <Dialog open={isOpen} onClose={handleClose} className={classes.dialog}>
        //     <DialogContent className={classes.content}>
        //         <MicIcon className={classes.icon} />
        //         <Typography variant="h5" component="div" className={classes.title} fontWeight="bold">
        //             Microphone Access Required
        //         </Typography>
        //         <Typography variant="body1" paragraph>
        //             To proceed ahead with the assigned {context}, we need access to your microphone.
        //         </Typography>
        //         <Typography variant="body2" color="textSecondary">
        //             You can change this setting at any time in your browser settings.
        //         </Typography>
        //     </DialogContent>
        //     <DialogActions className={classes.actions}>
        //         <Button onClick={handleClose} variant="outlined" placeholder="Not Now" />
        //         <Button onClick={handleAllow} variant="contained" placeholder="Allow Access" />
        //     </DialogActions>
        // </Dialog>

        <React.Fragment>
            <Dialog open={isOpen} PaperProps={{ classes: { root: classes.dialogPaper } }}>
                <Box className={classes.dialogBox}>
                    <DialogContent className={classes.dialogContent}>
                        <Typography className={classes.dialogTitle}>
                            Microphone Access Required
                        </Typography>
                        <Box className={classes.micImageContainer}>
                            <img className={classes.micImage} src={noMicSvg} alt="" />
                            <Typography className={classes.micText}>
                                Microphone
                                <Typography className={classes.micStatus}>Microphone Off</Typography>
                            </Typography>
                        </Box>
                        <Box className={classes.permissionTextContainer}>
                            <Typography className={classes.permissionText}>
                                To proceed ahead, we need access to your microphone.
                            </Typography>
                            <Typography className={classes.permissionSubText}>
                                You can change this setting at any time in your browser settings.
                            </Typography>
                        </Box>
                    </DialogContent>
                    {/* <Box className={classes.closeIconContainer} onClick={handleClose}>
                        <img
                            className={classes.closeIcon}
                            // style={{ width: '70%' }}
                            src={closeIconSvg} alt="" />
                    </Box> */}
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-20px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: 'linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)',
                        padding: '5px',
                        borderRadius: '50px'
                    }}>
                        <Button sx={{
                            background: 'linear-gradient(to top, #309906, #32a305, #34ad04, #36b703, #38c102, #3ec909, #44d110, #4ad916, #54e121, #5ee92a, #68f132, #71f93a)',
                            padding: '10px 40px',
                            borderRadius: '50px'
                        }} onClick={handleAllow}>
                            <Typography sx={{
                                fontSize: '1.5em',
                                fontFamily: '"Quicksand", sans-serif',
                                fontWeight: '600',
                                textAlign: 'center',
                                color: '#ffffff'
                            }}>
                                Allow
                            </Typography>
                        </Button>
                        {/* <Button onClick={handleAllow} variant="contained" placeholder="Allow Access" /> */}
                    </Box>
                </Box>
            </Dialog >
            {permissionState === MediaPermissionsState.GRANTED && <MicrophoneChecker sampleRate={16000} />}
        </React.Fragment>
    );
};

export default MicPermission;